window.SwymCallbacks = window.SwymCallbacks || [];
window.SwymCallbacks.push(function (swat) {
  var page = document.getElementById('wishlistPage');
  if (!page) return;

  var listsView = document.getElementById('wlListsView');
  var listsGrid = document.getElementById('wlListsGrid');
  var emptyState = document.getElementById('wlEmpty');
  var detailView = document.getElementById('wlDetailView');
  var shareModal = document.getElementById('wlShareModal');
  var deleteModal = document.getElementById('wlDeleteModal');
  var shareForm = document.getElementById('wlShareForm');
  var addToggle = document.getElementById('wlAddToggle');
  var addForm = document.getElementById('wlAddForm');
  var shareLid = null;
  var deleteLid = null;
  var lastFocus = null;

  (function adoptSwymStatus(attempt) {
    var status = document.querySelector('.swym-wishlist-page .swym-user-login-status');
    var slot = document.getElementById('wlAccount');
    if (status && slot) {
      slot.appendChild(status);
      return;
    }
    if (attempt < 20) {
      setTimeout(function () { adoptSwymStatus(attempt + 1); }, 250);
    } else {
      document.body.classList.add('wl-swym-fallback');
    }
  })(0);

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function imageUrl(src, width) {
    if (!src) return '';
    var base = String(src).split('?')[0];
    base = base.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|\d+x\d*)(\.[a-z]{2,4})$/i, '$2');
    return base + '?width=' + width;
  }

  function fetchLists() {
    return new Promise(function (resolve, reject) {
      swat.fetchLists({ callbackFn: resolve, errorFn: reject });
    });
  }

  function fetchListDetails(lid) {
    return new Promise(function (resolve, reject) {
      swat.fetchListDetails({ lid: lid }, resolve, reject);
    });
  }

  function productDetails(item) {
    return new Promise(function (resolve, reject) {
      swat.getProductDetails({ empi: item.empi, epi: item.epi, du: item.du }, resolve, reject);
    });
  }

  function openModal(modal) {
    lastFocus = document.activeElement;
    modal.classList.add('wl-open');
    var target = modal.querySelector('input, button:not(.wl-modal__close)');
    if (target) target.focus();
  }

  function closeModal(modal) {
    modal.classList.remove('wl-open');
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
  }

  [shareModal, deleteModal].forEach(function (modal) {
    modal.addEventListener('click', function (evt) {
      if (evt.target === modal || evt.target.closest('[data-wl-close]')) closeModal(modal);
    });
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key !== 'Escape') return;
    [shareModal, deleteModal].forEach(function (modal) {
      if (modal.classList.contains('wl-open')) closeModal(modal);
    });
  });

  function initAjaxCart() {
    if (!window.ajaxCart) return;
    window.ajaxCart.init({
      formSelector: '.AddToCartForm',
      cartContainer: '#CartContainer',
      addToCartSelector: '#AddToCart',
      cartCountSelector: '#CartCount',
      moneyFormat: window.Currency
        ? window.Currency.moneyFormats[window.Currency.shopCurrency].money_format
        : window.default_currency_format
    });
  }

  function showLists() {
    detailView.hidden = true;
    detailView.replaceChildren();
    listsView.hidden = false;
    renderLists();
  }

  function listSkeleton() {
    var card = document.createElement('article');
    card.className = 'wl-list-card wl-skel';
    card.innerHTML =
      '<div class="wl-list-card__open">' +
      '<span style="display: block; height: 18px; width: 60%; background: #f0f0f0; margin: 10px auto 15px;"></span>' +
      '<span class="wl-list-card__thumbs">' +
      '<span style="width: 48%; background: #f0f0f0;"></span>' +
      '<span style="width: 48%; background: #f0f0f0;"></span>' +
      '</span>' +
      '<span style="display: block; height: 12px; width: 30%; background: #f0f0f0; margin: 10px auto 0;"></span>' +
      '</div>';
    return card;
  }

  function renderLists() {
    listsGrid.replaceChildren(listSkeleton());
    emptyState.hidden = true;
    fetchLists()
      .then(function (lists) {
        if (!lists.length) {
          listsGrid.replaceChildren();
          emptyState.hidden = false;
          return;
        }
        Promise.all(
          lists.map(function (list) {
            return fetchListDetails(list.lid)
              .then(function (contents) {
                return buildListCard(contents.list, contents.items);
              })
              .catch(function () { return null; });
          })
        ).then(function (cards) {
          listsGrid.replaceChildren.apply(listsGrid, cards.filter(Boolean));
        });
      })
      .catch(function () {
        listsGrid.replaceChildren();
        emptyState.hidden = false;
      });
  }

  function buildListCard(list, items) {
    var card = document.createElement('article');
    card.className = 'wl-list-card';
    var count = items.length === 1 ? '1 item' : items.length + ' items';
    card.innerHTML =
      '<button type="button" class="wl-list-card__open">' +
      '<span class="wl-list-card__name">' + esc(list.lname) + '</span>' +
      '<span class="wl-list-card__thumbs"></span>' +
      '<span class="wl-list-card__count">' + count + '</span>' +
      '</button>' +
      '<button type="button" class="wl-share" aria-label="Share ' + esc(list.lname) + ' via email"></button>';

    var thumbs = card.querySelector('.wl-list-card__thumbs');
    items.slice(0, 2).forEach(function (item) {
      var image = document.createElement('img');
      image.alt = '';
      image.loading = 'lazy';
      if (item.iu) {
        image.src = imageUrl(item.iu, 420);
        thumbs.appendChild(image);
      } else {
        productDetails(item)
          .then(function (product) {
            image.src = imageUrl(product.featured_image, 420);
            thumbs.appendChild(image);
          })
          .catch(function () {});
      }
    });

    card.querySelector('.wl-list-card__open').addEventListener('click', function () {
      openList(list, items.length);
    });
    card.querySelector('.wl-share').addEventListener('click', function () {
      shareLid = list.lid;
      openModal(shareModal);
    });
    return card;
  }

  function skeletonCard() {
    var card = document.createElement('div');
    card.className = 'grid__item large--one-quarter medium--one-half small--one-half';
    card.innerHTML =
      '<div class="grid-view-item wl-skel">' +
      '<div style="height: 0; width: 100%; padding-top: 150%; background-color: #f7f7f7; position: relative;"></div>' +
      '<div style="height: 14px; width: 70%; background: #f0f0f0; margin: 12px 5px 0;"></div>' +
      '<div style="height: 14px; width: 30%; background: #f0f0f0; margin: 8px 5px 0;"></div>' +
      '</div>';
    return card;
  }

  function openList(list, itemCount) {
    listsView.hidden = true;
    detailView.hidden = false;
    detailView.innerHTML =
      '<div class="wl-detail-head">' +
      '<button type="button" class="wl-back">&laquo; Back</button>' +
      '<h2 class="wl-detail-title">' + esc(list.lname) + '</h2>' +
      '<button type="button" class="wl-btn wl-btn--ghost wl-delete-list">Delete List</button>' +
      '</div>' +
      '<div class="wl-grid"></div>';

    detailView.querySelector('.wl-back').addEventListener('click', showLists);
    detailView.querySelector('.wl-delete-list').addEventListener('click', function () {
      deleteLid = list.lid;
      openModal(deleteModal);
    });

    var grid = detailView.querySelector('.wl-grid');
    var skeletons = Math.min(itemCount || 4, 12);
    for (var i = 0; i < skeletons; i++) {
      grid.appendChild(skeletonCard());
    }
    window.scrollTo(0, 0);

    fetchListDetails(list.lid)
      .then(function (contents) {
        if (!contents.items.length) {
          grid.outerHTML = '<div class="wl-empty"><p>This list is empty.</p></div>';
          return;
        }
        var cards = contents.items.map(function (item) {
          return buildProductCard(item, list.lid);
        });
        grid.replaceChildren.apply(grid, cards);
        var remaining = contents.items.length;
        contents.items.forEach(function (item, i) {
          productDetails(item)
            .then(function (product) {
              hydrateProductCard(cards[i], product);
            })
            .catch(function () {})
            .then(function () {
              remaining -= 1;
              if (remaining === 0) initAjaxCart();
            });
        });
      })
      .catch(function () {});
  }

  function buildProductCard(item, lid) {
    var card = document.createElement('div');
    card.className = 'grid__item large--one-quarter medium--one-half small--one-half';
    card.style.visibility = 'visible';
    card.style.animationName = 'fadeIn';
    card.innerHTML =
      '<div class="grid-view-item">' +
      '<div class="grid-view-item-image">' +
      '<a href="' + esc(item.du) + '" title="' + esc(item.dt) + '" class="grid__image grid__image__match">' +
      '<div style="height: 0; width: 100%; padding-top: 150%; background-color: #f7f7f7; position: relative;">' +
      '<img class="img-responsive" src="' + esc(imageUrl(item.iu, 720)) + '" alt="' + esc(item.dt) + '" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover; opacity: 0; transition: opacity 0.2s ease;" loading="lazy">' +
      '</div>' +
      '</a>' +
      '<div class="variants-options"></div>' +
      '</div>' +
      '<button type="button" class="quick-shop-quickadd">' +
      '<span class="quick-shop-quickadd__icon">+</span>' +
      '<span class="quick-shop-quickadd__text"> Quick Add</span>' +
      '</button>' +
      '<div class="grid-view-item--desc-wrapper">' +
      '<div>' +
      '<div class="title-row" style="display: flex;">' +
      '<p class="product-grid--title search-grid"><a href="' + esc(item.du) + '">' + esc(item.dt) + '</a></p>' +
      '<div style="position: relative; margin-left: auto; padding-left: 10px;">' +
      '<a class="wl-remove-item" role="button" tabindex="0" aria-label="Remove ' + esc(item.dt) + ' from list">' +
      '<i class="fa fa-heart fa-lg" aria-hidden="true" style="position: relative; float: right; right: 7px; font-size: 1em; line-height: 1.3;"></i>' +
      '</a>' +
      '</div>' +
      '</div>' +
      '<p class="product-grid--price search-grid"></p>' +
      '<div class="more-colours-collection"><div class="more-colours-collection--wrapper"></div></div>' +
      '</div>' +
      '</div>' +
      '</div>';

    var image = card.querySelector('img');
    image.addEventListener('load', function () {
      image.style.opacity = '1';
    });
    if (image.complete && image.naturalWidth) image.style.opacity = '1';

    card.querySelector('.quick-shop-quickadd').addEventListener('click', function (evt) {
      evt.preventDefault();
      var gridItem = card.querySelector('.grid-view-item');
      var open = gridItem.classList.contains('variants-options-on');
      document.querySelectorAll('.grid-view-item.variants-options-on').forEach(function (other) {
        other.classList.remove('variants-options-on');
      });
      if (!open) gridItem.classList.add('variants-options-on');
    });

    function removeItem() {
      swat.deleteFromList(
        lid,
        { epi: item.epi, empi: item.empi, du: item.du },
        function () {
          var grid = card.parentElement;
          card.remove();
          if (grid && !grid.querySelector('.grid-view-item')) {
            grid.outerHTML = '<div class="wl-empty"><p>This list is empty.</p></div>';
          }
        },
        function () {}
      );
    }
    var removeEl = card.querySelector('.wl-remove-item');
    removeEl.addEventListener('click', removeItem);
    removeEl.addEventListener('keydown', function (evt) {
      if (evt.key === 'Enter' || evt.key === ' ') {
        evt.preventDefault();
        removeItem();
      }
    });
    return card;
  }

  function toCents(value) {
    return Number.isInteger(value) ? value : Math.round(Number(value) * 100);
  }

  function renderPrice(card, product) {
    var priceEl = card.querySelector('.product-grid--price');
    if (!priceEl || product.price == null || !window.Shopify || !Shopify.formatMoney) return;
    var format = (window.currencySymbol || '$') + '{{ amount }}';
    var min = product.price_min != null ? product.price_min : product.price;
    var max = product.price_max != null ? product.price_max : product.price;
    var priceString = min !== max
      ? Shopify.formatMoney(toCents(min), format) + ' - ' + Shopify.formatMoney(toCents(max), format)
      : Shopify.formatMoney(toCents(min), format);
    var html = '<span style="font-size: 1em; font-weight: 700; line-height: 15px;" class="money">' + priceString + '</span>';
    var compare = product.compare_at_price_max != null ? product.compare_at_price_max : product.compare_at_price;
    if (compare && toCents(compare) > toCents(max)) {
      html += ' <s style="color: #999; font-size: 0.9em;"><span class="money">' + Shopify.formatMoney(toCents(compare), format) + '</span></s>';
    }
    priceEl.innerHTML = html;
  }

  function hydrateProductCard(card, product) {
    if (product.featured_image) {
      card.querySelector('img').src = imageUrl(product.featured_image, 720);
    }
    renderPrice(card, product);
    var variants = card.querySelector('.variants-options');
    if (product.options && product.options.length > 1) {
      variants.innerHTML =
        '<div class="quick-add-to-cart clearfix AddToCartForm">' +
        '<a tabindex="-1" href="/products/' + esc(product.handle) + '" style="display: block!important;" class="seeCartOptions">See Options</a>' +
        '</div>';
      return;
    }
    (product.variants || []).forEach(function (variant) {
      if (!variant.available) return;
      var form = document.createElement('form');
      form.className = 'quick-add-to-cart clearfix AddToCartForm';
      form.action = '/cart/add';
      form.method = 'post';
      form.enctype = 'multipart/form-data';
      form.innerHTML =
        '<input type="hidden" name="id" value="' + esc(variant.id) + '">' +
        '<input type="submit" name="add" id="AddToCart" class="AddToCart" value="' + esc(variant.title) + '" ' +
        'data-ph-capture-attribute-product-name="' + esc(product.title) + '" ' +
        'data-ph-capture-attribute-page-type="Wishlist">';
      variants.appendChild(form);
    });
    variants.insertAdjacentHTML(
      'beforeend',
      '<div class="cart-lds-ring cart-spinner-collections" style="display: none"><div></div><div></div><div></div><div></div></div>'
    );
  }

  document.getElementById('wlDeleteConfirm').addEventListener('click', function () {
    closeModal(deleteModal);
    if (deleteLid == null) return;
    swat.deleteList(
      deleteLid,
      function () {
        deleteLid = null;
        showLists();
      },
      function () {}
    );
  });

  shareForm.addEventListener('submit', function (evt) {
    evt.preventDefault();
    if (shareLid == null) return;
    swat.sendListViaEmail(
      {
        toEmailId: shareForm.elements.email.value,
        fromName: shareForm.elements.name.value,
        note: 'Hey, check out these products!',
        lid: shareLid,
        cprops: {}
      },
      function () {},
      function () {}
    );
    shareForm.reset();
    closeModal(shareModal);
  });

  addToggle.addEventListener('click', function () {
    addForm.hidden = !addForm.hidden;
    if (!addForm.hidden) document.getElementById('wlAddInput').focus();
  });

  function setAddError(on) {
    addForm.classList.toggle('wl-error', on);
    document.getElementById('wlAddError').hidden = !on;
  }

  document.getElementById('wlAddInput').addEventListener('input', function () {
    setAddError(false);
  });

  addForm.addEventListener('submit', function (evt) {
    evt.preventDefault();
    var name = document.getElementById('wlAddInput').value.trim();
    if (!name) return;
    setAddError(false);
    swat.createList(
      { lname: name },
      function () {
        addForm.reset();
        addForm.hidden = true;
        renderLists();
      },
      function () {
        setAddError(true);
      }
    );
  });

  renderLists();
});

Array.prototype.forEach.call(
  document.getElementsByClassName('swym-wishlist-container-content'),
  function (el) { el.style.display = 'none'; }
);
